import React from 'react';
import ListPageShell from '../components/ListPageShell/ListPageShell';
import DataTable from '../components/DataTable/DataTable';
import Pagination from '../components/Pagination/Pagination';

export default function GenericListView({
    title,
    subtitle,
    actions,
    header,                  // any ReactNode (FilterContainer or SearchHeader)
    columns,
    tableProps,              // { rows, sortBy, sortDir, onSort, loading, error }
    paginationProps,         // { page, size, total, onPage }
    actionCell,              // (row) => ReactNode
    actionHeader = 'Actions' // string (optional)
}) {
    return (
        <ListPageShell
            title={title}
            subtitle={subtitle}
            actions={actions}
            headerExtras={header}
            table={
                <DataTable
                    columns={columns}
                    actionCell={actionCell}
                    actionHeader={actionHeader}
                    {...tableProps}
                />
            }
            pagination={<Pagination {...paginationProps} />}
        />
    );
}
